import { useMemo } from 'react';
import { useLocalCurrencyContext } from 'src/providers';
import { orderBy } from 'lodash';

export const useSortedTickers = ({ tickers, filter }) => {
  const localCurrency = useLocalCurrencyContext();

  const sortedTickers = useMemo(
    () =>
      orderBy(
        tickers.filter(filter),
        [ticker => ticker.data.pair.includes(localCurrency), ticker => ticker.data.volumeInNOK],
        ['desc', 'desc']
      ).map(ticker => ticker.data),
    [tickers, filter, localCurrency]
  );

  return sortedTickers;
};
